<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :stripe="false" search-btn-hide right-toolbar-hide no-auto-height :auto-scroll="false" row-key="BJ_EBC_ID" :reset-data="resetDataFn" lazy :load="loadMethod" :row-style="treeRowStyleFun" :check-method="checkMethod" @handleTableDataChange="handleTableDataChange" @handleSelectionChange="handleSelectionChange">
      <template v-slot:tableColumn>
        <el-table-column :label="$t('OrdinaryOrderMix.OrderItemTable.name')" prop="skuName" align="center" />
        <el-table-column :label="$t('OrdinaryOrderMix.OrderItemTable.SKU')" prop="standardSkuCode" align="center" />
        <el-table-column :label="$t('OrdinaryOrderMix.OrderItemTable.SPU')" prop="batchNumList" align="center">
          <template slot-scope="scope">
            <BjSelectLov v-model="scope.row.spuCode" :option-list="scope.row.batchNumList" :placeholder="$t('OrdinaryOrderMix.OrderItemTable.SPU')" clearable />
          </template>
        </el-table-column>
        <el-table-column :label="$t('OrdinaryOrderMix.OrderItemTable.Quantity')" prop="quantity" align="center">
          <template slot-scope="scope">
            <BjInputNumber v-if="!scope.row.isChildSku" v-model="scope.row.quantity" :maxlength="MAX_LENGTH.DEFAULT" class="full-width" :min="0" :precision="0" :controls="false" onkeyup="this.value = this.value.replace(/[^\d]/g,'').replace(/^0{1,}/g,'')" @input="onBlurQuantity(scope.row)" />
            <span v-if="scope.row.isChildSku">{{ scope.row.num }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('BusinessBatchInventoryQuery.table.usableNum2')" prop="usableNum" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.batchNumList && scope.row.batchNumList.length>0"> {{ scope.row.batchNumList.bjGet(scope.row.spuCode, 'value', 'usableNum') }} </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('OrdinaryOrderMix.OrderItemTable.Operation')" align="center" fixed="right" width="120">
          <template slot-scope="scope">
            <!-- 子商品不可单独删除 -->
            <el-button :disabled="$route.query.orderHandleStatus == 3" v-show="!scope.row.isChildSku" type="text" @click="onDelete(scope.row)">{{ $t('OrdinaryOrderMix.OrderItemTable.Delete') }}</el-button>
          </template>
        </el-table-column>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { SKU_GIFT_TYPE_LIST_FOR_CREATE } from '@/utils/constants';
import skuApi from '@/api/goodsApi/skuApi';
export default {
  name: 'BusinessOrderInternalOrderItemTable',
  components: {},
  mixins: [pageMiXin],
  props: {
    tableData: {
      type: Array,
      default: function () {
        return [];
      },
    },
    defaultQueryParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      serial: true,
      selection: true,
      SKU_GIFT_TYPE_LIST_FOR_CREATE,
      // 查询参数
      queryParams: {
        id: null,
      },

      selectedRows: null,
      expandTableSelectedObj: null,
    };
  },
  watch: {},
  created() {
    if (this.defaultQueryParams) {
      this.queryParams = { ...this.queryParams, ...this.defaultQueryParams };
    }
  },
  methods: {
    treeRowStyleFun({ row, rowIndex }) {
      return this.$treeRowStyleFun({ row, rowIndex }, 'isChildSku', true);
    },
    checkMethod(row) {
      return !row.isChildSku;
    },
    // 更新父组件数据
    handleTableDataChange(v) {
      const TEMP = this.tableData.map(e => {
        const FIND = (v || []).find(ee => ee.BJ_EBC_ID == e.BJ_EBC_ID);
        if (FIND) {
          return FIND;
        }
        return e;
      });
      this.$emit('update:tableData', TEMP);
    },
    // 主表查询API
    queryApi(queryParams) {
      const start = queryParams.currentPage * queryParams.pageSize;
      const end = queryParams.page * queryParams.pageSize;
      return new Promise(resolve => {
        resolve({
          content: this.tableData.slice(start, end),
          totalElements: this.tableData.length, // 数据总数
        });
      });
    },

    // 子表查询API
    childrenQueryApi(queryParams) {
      return skuApi.getMealsGoodsList(queryParams);
    },
    onDelete(row) {
      this.$emit('delete', row);
    },
    handleSelectionChange(d) {
      this.$emit('selection-change', d);
    },
    onChangeGiftFlag(row) {
      this.$nextTick(() => {
        if (row.giftFlag == 1) {
          row.outerSaleAmount = '';
          row.transPrice = '';
        } else {
          this.onBlurQuantity(row);
        }
      });
    },
    onBlurQuantity(row) {
      console.warn('onBlurQuantity', row);
      if (row.outerSingleSaleAmount != undefined) {
        row.outerSaleAmount = this.$number2money(
          (row.outerSingleSaleAmount || 0) * (row.quantity || 0),
        );
        row.innerSaleAmount = this.$number2money(
          (row.innerSingleSaleAmount || 0) * (row.quantity || 0),
        );
        row.costAmount = this.$number2money((row.costPrice || 0) * (row.quantity || 0));
      }
    },
    /** * */
    resetDataFn(data) {
      return data.map(e => {
        return { BJ_HAS_CHILD: true, BJ_PARENT_ID: null, ...e };
      });
    },
    // onAction(action) {
    //   const hasChildren = true;
    //   this.$emit('onAction', action, hasChildren, this.selectedRows);
    // },
    loadMethod({ row }) {
      // 异步加载子节点
      return new Promise((resolve, reject) => {
        this.childrenQueryApi([row.skuCode]).then(res => {
          const TEMP = (Array.isArray(res) ? res : []).map(e => {
            return { ...e, BJ_HAS_CHILD: false, BJ_PARENT_ID: row.BJ_EBC_ID, isChildSku: true };
          });

          if (TEMP.length) {
            resolve(TEMP);
          } else {
            this.$message.warning(this.$t('OrdinaryOrderMix.OrderItemTable.returned'));
            reject();
          }
        });
      });
    },

    onSkuLineLog() {},
  },
};
</script>
